import { BaseErrorFallback } from './components';

const SidebarErrorFallback = () => <BaseErrorFallback size="sm" />;

export default SidebarErrorFallback;
